import { useRef, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import TitleAndImage from "../components/molecules/title-and-image";
import arrow_back from "../assets/icons/arrow_back.svg";
import check_grey_circle from "../assets/icons/check_grey_circle.svg";
import arrow_grey_circle from "../assets/icons/arrow_grey_circle.svg";
import check_orange_circle from "../assets/icons/check_orange_circle.svg";
import arrow_blue_circle from "../assets/icons/arrow_blue_circle.svg";
import SignaturePad from "react-signature-canvas";
import SignatureCanvas from "react-signature-canvas";
import MessagesReactModal from "../components/templates/messages-react-modal";
import screen_rotation from "../assets/icons/screen_rotation.svg";
import { addContractSignatureData } from "../redux/slices/contractSignatureReducer";
import listText from "../utils/dictionaries/dictionary-customer-signature-action";

const CustomerSignatureAction = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [modalShow, setModalShow] = useState(false);
  const [disableButtons, setDisableButtons] = useState(true);
  const padRef = useRef<SignatureCanvas>(null);

  const clearPad = () => {
    padRef.current?.clear();
    setDisableButtons(true);
  };
  const saveTrimImage = () => {
    const imgPngbase64 = padRef.current?.getTrimmedCanvas().toDataURL("image/png");
    if (imgPngbase64) {
      dispatch(
        addContractSignatureData({
          signatureImageBase64: imgPngbase64,
        }),
      );
      navigate("/CustomerSignatureShow");
    }
  };
  const checkDevicePosition = () => {
    if (
      screen.orientation.type === "portrait-primary" ||
      screen.orientation.type === "portrait-secondary"
    ) {
      setModalShow(true);
    } else {
      setModalShow(false);
    }
  };
  useEffect(() => {
    checkDevicePosition();
    window.addEventListener(
      "orientationchange",
      function () {
        checkDevicePosition();
      },
      false,
    );
  }, [screen]);

  const enabledButtons = () => {
    return (
      <div>
        <img
          src={`${check_orange_circle}`}
          style={{ marginRight: "20px" }}
          onClick={() => saveTrimImage()}
        />
        <img src={`${arrow_blue_circle}`} style={{}} onClick={() => clearPad()} />
      </div>
    );
  };
  const disabledButtons = () => {
    return (
      <div>
        <img src={`${check_grey_circle}`} style={{ marginRight: "20px" }} />
        <img src={`${arrow_grey_circle}`} style={{}} />
      </div>
    );
  };

  return (
    <>
      <div className="content-container">
        <div className="rounded-bottom-3 p-1" style={{ backgroundColor: "#00376F" }}>
          <TitleAndImage
            srcImage={arrow_back}
            titleText={listText.text_1.mainText}
            displayLeftImageTitle={""}
            classTitle={`fw-bold fs-5 ms-2`}
            styleTitle={{ color: "white" }}
            onClickGoBackIcon={() => navigate("/ContractCondition")}
            divClass={"mt-3 mb-3"}
          />
        </div>
        <div className="container mt-3">
          <SignaturePad
            ref={padRef}
            canvasProps={{ className: "signature-canvas" }}
            onEnd={() => setDisableButtons(false)}
          />
        </div>
      </div>
      <div className="footer--pin text-center mt-2">
        {disableButtons ? disabledButtons() : enabledButtons()}
      </div>
      <MessagesReactModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textTitle={listText.text_2.mainText}
        classTitle={"fw-bold"}
        styleTitle={{ color: "#00254A", fontSize: "20px", fontWeight: "700" }}
        listButtonsModal={[]}
        imageModal={screen_rotation}
        classContent={"text-center"}
        classImageModal={"text-center my-4"}
        classImageCloseModal={"d-none"}
        backdrop={"static"}
        listParagraphs={[
          {
            textParagraph: listText.text_3.mainText,
            classParagraph: "mt-2 mx-2",
            styleParagraph: { fontSize: 16, color: "#00254A", fontWeight: "450" },
          },
          {
            textParagraph: listText.text_4.mainText,
            classParagraph: "mt-2 mx-2",
            styleParagraph: { fontSize: 16, color: "#00254A", fontWeight: "450" },
          },
        ]}
      />
    </>
  );
};

export default CustomerSignatureAction;
